import { z } from "zod";

export const rateSchema = z.object({
    room_type_id: z.string().min(1, "Room type ID is required"),
    // String kosong diperbolehkan: drag & drop ke baris "Unassigned" mengirim
    // room_id '' (lihat CalendarBooking.tsx eventDrop), backend men-treat itu
    // sebagai null lewat middleware.
    room_id: z.string(),
    // Level SAMA dengan room_type_id/room_id di atas (bukan di dalam `rates`).
    // Optional supaya payload booking normal (rate_plan_id sudah ter-mapping)
    // TIDAK berubah sama sekali -- hanya dikirim untuk kasus booking unmapped
    // di MoveReservationContent.tsx (lihat `isUnmapped`).
    rate_plan_id: z.string().optional(),
    rates: z.array(
        z.object({
            date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
            rate: z.coerce.number().min(0, "Rate must be a positive number"),
        })
    ),
});

export type RateType = z.infer<typeof rateSchema>;